export enum OPERATOR {
    CHINA_UNICOM = '中国联通',
    UNICON_CES = '联通CES',
    LENOVO_CONNECT = '懂的通信',
    HUE = 'HUE',
    TRUPHONE = 'Truphone',
    FIVE_G = '蜂窝平台'
}

export enum OPERATOR_V {
    CHINA_UNICOM = 1,
    LENOVO_CONNECT = 4,
    UNICON_CES = 5,
    HUE = 6,
    TRUPHONE = 7,
    FIVE_G = 8
}

export enum GOODS_TYPE {
    JIAYOU = '加油包',
    JICHU = '基础包',
    SHENGJI = '升级包',
    JIFEN = '积分商品',
    XUNI = '虚拟商品',
    SHIWU = '实物商品',
    MAHAO = '码号商品',
    ZHUIJIA = '追加包',
    YOUHUI = '优惠券',
    TIYAN = '体验包',
    DUIHUANQUAN = '兑换券',
    JIALIANG = '加量包',
    PACKAGE_CHANGE = '变更服务',
    RECHARGE = '充值包'
}

export enum GOODS_TYPE_V {
    JIAYOU = '1',
    JICHU = '2',
    SHENGJI = '3',
    JIFEN = '4',
    XUNI = '5',
    SHIWU = '6',
    MAHAO = '7',
    ZHUIJIA = '8',
    YOUHUI = '9',
    TIYAN = '10',
    DUIHUANQUAN = '11',
    JIALIANG = '12',
    PACKAGE_CHANGE = '13',
    RECHARGE = '15'
}
export enum COMMERCIALIZATION_GOODS_LABEL {
    FLOW = '流量商品',
    UPGRADE = '升级服务',
    VIRTUAL = '虚拟商品',
    PHYSICS = '实物商品',
    PROFILE = '码号商品',
    DISCOUNT = '优惠券',
    EXCHANGE = '兑换券',
    // INTEGRAL_GOODS = '积分商品',
    ChANGE_SERVICE = '套餐变更',
    BLIND_BOX = '盲盒',
}

export enum COMMERCIALIZATION_GOODS_LABEL_V {
    FLOW = '1',
    UPGRADE = '2',
    VIRTUAL = '3',
    PHYSICS = '4',
    PROFILE = '5',
    DISCOUNT = '6',
    EXCHANGE = '7',
    // INTEGRAL_GOODS = '8',
    ChANGE_SERVICE = '9',
    BLIND_BOX = '10'
}
export enum TAB_BAR_VALUE {
    HOME_IDX = 'home',
    MINE_IDX = 'mine'
}

export enum COOKIE_KEYS {
    TOKEN = 'token'
}

export enum LOCALSTORAGE_KEYS {
    USERINFO = 'userInfo'
}

export enum REGION_V {
    US = 'US',
    AT = 'AT', // 奥地利
    BE = 'BE', // 比利时
    CH = 'CH', // 瑞士
    DE = 'DE', // 德国
    DK = 'DK', // 丹麦
    ES = 'ES', // 西班牙
    FI = 'FI', // 芬兰
    FR = 'FR', // 法国
    IE = 'IE', // 爱尔兰
    IT = 'IT', // 意大利
    LUX = 'LU', // 卢森堡
    NL = 'NL', // 荷兰
    NO = 'NO', // 挪威
    PT = 'PT', // 葡萄牙
    SE = 'SE', // 瑞典
    GB = 'GB', // 英国
}

/*
* input输入框ADDON类型
* */
export enum INPUT_ADDON_TYPE {
    DATE_UNIT = 'dateUnit',
    FLOW_UNIT = 'flowUnit',
}

/*
* 时间单位
* */
export enum DATE_UNIT {
    MONTH = '个月',
    DAY = '天'
}

export enum DATE_UNIT_V {
    MONTH = '0',
    DAY = '1'
}

export enum GOODS_OPERATOR_TYPE {
    PREPAID = '1',
    MONTHPAID = '0'
}

export enum GOODS_OPERATOR_TYPE_V {
    PREPAID = '1',
    MONTHPAID = '0'
}

/*
* 限速状态
* */
export enum LIMIT_STATE {
    YES = '限速',
    NO = '未限速'
}

export enum LIMIT_STATE_V {
    YES = '1',
    NO = '0'
}

/*
* 流量单位
* */
export enum FLOW_UNIT {
    KB = 'KB',
    MB = 'MB',
    GB = 'GB',
    TB = 'TB',
    PB = 'PB',
}

export enum FLOW_UNIT_V {
    KB = 0,
    MB = 1,
    GB = 2,
    TB = 3,
    PB = 4,
}

/*
* 流量单位
* */
export enum ORDER_STATE {
    TO_BE = '待支付',
    SUCCESS = '支付成功',
    FAIL = '支付失败',
    TASK_SUCCESS = '办理成功',
    TASK_FAIL = '办理失败'
}

export enum ORDER_STATE_V {
    TO_BE = '0',
    SUCCESS = '1',
    FAIL = '2',
    TASK_SUCCESS = '3',
    TASK_FAIL = '4'
}

/*产品管理 流量类型*/
export enum TRAFFIC_TYPE {
    NATION_CURRENCY = '全国通用'
}

export enum TRAFFIC_TYPE_V {
    NATION_CURRENCY = '1'
}

/*产品发布 订购时长
*   ONE_MONTH("1", "一个月"),

    SIX_MONTH("2", "6个月"),

    TWELVE_MONTH("3", "12个月");
* */
export enum PRODUCT_ORDERING_TIME {
    ONE_MONTH = '1个月',
    SIX_MONTH = '6个月',
    TWELVE_MONTH = '12个月',
}

export enum PRODUCT_ORDERING_TIME_V {
    ONE_MONTH = '1',
    SIX_MONTH = '2',
    TWELVE_MONTH = '3'

}

/*
* 商品发布包类型
* */
export enum GOODS_RELEASE_TYPE {
    EXCELLENT = '优享包',
    FANCY = '畅享包',
    SPEED = '提速包'
}

export enum GOODS_RELEASE_TYPE_V {
    EXCELLENT = '1',
    FANCY = '2',
    SPEED = '3'
}

/*
* 商品发布价格类型
* */
export enum GOODS_PRICE_TYPE {
    NORMAL = '正常售价',
    DISCOUNT = '限时优惠',
    HOLIDAY = '国庆特惠',
    ACTIVITY = '活动优惠',
}

export enum GOODS_PRICE_TYPE_V {
    NORMAL = '1',
    DISCOUNT = '2',
    HOLIDAY = '999',
    ACTIVITY = '1000'
}

/*
* 订单类型
* */
export enum ORDER_TYPE {
    ACTIVE = '激活',
    ORDERING = '订购',
    EXCHANGE = '兑换',
    GIFT = '赠品',
    COMPANY = '企业订购',
    EXPERIENCE = '体验',
    UPGRADE = '升级',
    INTEGRAL_EXCHANGE = '积分兑换',
    CHANGE_PACKAGE = '套餐变更',
}

export enum ORDER_TYPE_V {
    ACTIVE = '1',
    ORDERING = '2',
    EXCHANGE = '4',
    GIFT = '5',
    COMPANY = '6',
    EXPERIENCE = '7',
    UPGRADE = '8',
    INTEGRAL_EXCHANGE = '10',
    CHANGE_PACKAGE = '11',
}

/**
 * 订单子类型
 */
export enum ORDER_SUB_TYPE {
    ACTIVE = '激活',
    ORDERING = '订购',
    EXCHANGE = '兑换',
    GIFT = '赠送',
    COMPANY = '分配',
    EXPERIENCE = '体验',
    UPGRADE = '升级服务',
    GAS = '加油包订购',
    DRAW = '抽奖奖品',
    SIGN_IN_GIFT = '签到',
    INTEGRAL_EXCHANGE = '积分兑换',
    CHANGE_PACKAGE = '套餐变更',
    VIRTUAL_GOODS = '虚拟商品',
    PHYSICAL_GOODS = '实物商品',
    PROFILE_GOODS = '码号商品',
    COUPON_DIS = '优惠券',
    COUPON_EX = '兑换券',
    EXTRA_PACKAGE = '加量包',
    CHANGE_GOODS = '变更商品',
    BLIND_BOX_ORDER = '盲盒订购',
    BLIND_BOX_EXCHANGE = '盲盒兑换',
}

export enum ORDER_SUB_TYPE_V {
    ACTIVE = '1',
    ORDERING = '2',
    EXCHANGE = '4',
    GIFT = '5',
    COMPANY = '6',
    EXPERIENCE = '7',
    UPGRADE = '8',
    GAS = '9',
    DRAW = '10',
    SIGN_IN_GIFT = '11',
    INTEGRAL_EXCHANGE = '12',
    CHANGE_PACKAGE = '13',
    VIRTUAL_GOODS = '14',
    PHYSICAL_GOODS = '15',
    PROFILE_GOODS = '16',
    COUPON_DIS = '17',
    COUPON_EX = '18',
    EXTRA_PACKAGE = '19',
    CHANGE_GOODS = '20',
    BLIND_BOX_ORDER = '21',
    BLIND_BOX_EXCHANGE = '22',
}

/*
* 日期格式类型
* */
export enum FORMAT_TYPES {
    MONTH = 'YYYY/MM',
    DATE = 'YYYY/MM/DD',
    DOT_DATE = 'YYYY.MM.DD',
    HOUR = 'YYYY/MM/DD HH',
    MINUTE = 'YYYY/MM/DD HH:mm',
    SECOND = 'YYYY/MM/DD HH:mm:ss',
    DATE_GLOBAL = 'DD/MM/YYYY',
    MINUTE_GLOBAL = 'HH:mm DD/MM/YYYY'
}

export const backDoorList = ['89860619100004141695', '89860619100004141752', '89860619100004141836', '89860619100004142370', '89860619100004142933', '89860619100004197382', '89860619100004141992', '89860619100004140572', '89860619100004142917']

/**
 * activity类型
 */
export enum GOODS_ACTIVITY_TYPE {
    NO_ACTIVITY = '无活动',
    FIRST_CHARGE = '首充活动',
    DIR_COUPONS = '定向兑换券',
    BIG_SALE = '限时打折',
    ACTIVE_FREE = '激活赠送',
    ORDER_FREE = '订购赠送',
    CONTINUE_SIGN = '连续签到',
    CUMULATIVE_SIGN = '累计签到'
}

export enum GOODS_ACTIVITY_TYPE_V {
    NO_ACTIVITY = 'FIRST_CHARGE',
    FIRST_CHARGE = 'FIRST_CHARGE',
    DIR_COUPONS = 'DIR_COUPONS',
    BIG_SALE = 'BIG_SALE',
    ACTIVE_FREE = 'ACTIVE_FREE',
    ORDER_FREE = 'ORDER_FREE',
    CONTINUE_SIGN = 'CONTINUE_SIGN',
    CUMULATIVE_SIGN = 'CUMULATIVE_SIGN'
}

export enum GOODS_RELEASE_PRICE_TYPE {
    DISCOUNT_PRICE = '限时折扣',
    RELEASE_PRICE = '正常销售'
}

export enum GOODS_RELEASE_PRICE_TYPE_V {
    DISCOUNT_PRICE = '1',
    RELEASE_PRICE = '2'
}

export enum PAY_ORDER_STATUS_V {
    TO_BE_PAID = '0',
    SUCCESS_PAY = '1',
    FAIL_PAY = '2',
    TASK_STATUS_SUCCESS = '3',
    TASK_STATUS_FAILD = '4',
    CANCEL_PAY = '5'
}

export enum PAY_ORDER_STATUS {
    TO_BE_PAID = '待支付',
    SUCCESS_PAY = '支付成功',
    FAIL_PAY = '支付失败',
    TASK_STATUS_SUCCESS = '办理成功',
    TASK_STATUS_FAILD = '办理失败',
    CANCEL_PAY = '取消交易'
}

export enum INVOICE_STATUS {
    APPLYING = '申请中',
    CANCELED = '已撤销',
    MADE = '已开票',
    REJECT = '已打回',
    POSTED = '已邮寄',
}

export enum INVOICE_STATUS_V {
    APPLYING = '0',
    CANCELED = '1',
    MADE = '2',
    REJECT = '3',
    POSTED = '4'
}

export enum INVOICE_TYPE {
    E_INVOICE = '电子发票',
    P_INVOICE = '纸质发票'
}

export enum INVOICE_TYPE_V {
    E_INVOICE = '0',
    P_INVOICE = '1'
}

export enum HEAD_TYPE {
    PERSONAL = '个人/非企业单位',
    ENTERPRICE = '企业单位'
}

export enum HEAD_TYPE_V {
    PERSONAL = '0',
    ENTERPRICE = '1'
}

export enum COUPON_TYPE {
    MINUS = '满减券',
    DISCOUNT = '折扣券',
    SKILL = '活动券'
}

export enum COUPON_TYPE_V {
    MINUS = '0',
    DISCOUNT = '1',
    SKILL = '2'
}

export enum COUPON_UNIT {
    COUNT = '折',
    RMB = '元'
}

export enum COUPON_UNIT_V {
    COUNT = '1',
    RMB = '0'
}

export enum COUPON_STATE {
    NORMAL = '正常领取',
    UP_LIMIT = '领取已达上限，不可领',
    FINISH = '优惠券已领完，不可领',
    OUT_DATE = '优惠券过期，不可领',
    NO_START = '优惠券未开始，不可领',
    NO_ACT = '无活动，不可领'
}

export enum COUPON_STATE_V {
    NORMAL = '1',
    UP_LIMIT = '2',
    FINISH = '3',
    OUT_DATE = '4',
    NO_START = '5',
    NO_ACT = '6'
}

export enum PLATFORM {
    MP = '移动套餐',
    APP = '小程序',
    H5 = 'h5'
}

export enum PLATFORM_V {
    MP = '1',
    APP = '2',
    H5 = '3'
}

/*
 货币类型
*/
export enum CURRENCY {
    RMB = '￥',
    EUR = '€',
    USD = '$',
    GBP = '￡',
    NOK = 'kr',
    DKK = 'kr',
    SEK = 'kr',
    CHF = '₣'
}

export enum CURRENCY_V {
    RMB = '0',
    EUR = '1',
    USD = '2',
    GBP = '3',
    NOK = '4',
    DKK = '5',
    SEK = '6',
    CHF = '7'
}

export enum EVENT_TRACING_PAGE {
    LOGIN = 'h5-login', // login页
    HOME = 'h5-home', // home页
    MINE = 'h5-mine', // 我的页面
    COUPON = 'h5-coupon', // 优惠卡券
    PAYMENT = 'h5-payment',
    COUPON_BANNER = 'h5-coupon-banner', // 优惠卡券
    ACTIVE_DETAIL = 'h5-active-detail'
}

// 埋点的 点击事件枚举
export enum EVENT_TRACING_CLICK {
    OP_LOGIN = 'h5-opLogin', // 登录
    OP_BANNER_CLICK = 'h5-opBannerClick', // banner 点击事件
    OP_HOME_ACTIVE_CLICK = 'h5-opHomeActiveClick', // 首页用户点击“立即领取”
    OP_HOME_ACTIVE_DIALOG_CLICK = 'h5-opHomeActiveDialogClick', // 首页用户在弹框点击“立即领取”
    OP_UPGRADE_SERVICE = 'h5-opUpgradeService', // 升级消息
    OP_ORDERING_CLICK = 'h5-opOrderingClick', // 套餐立即订购
    OP_ORDERING_GAS_CLICK = 'h5-opOrderingGasClick', // 加油包立即订购
    OP_COUPON_USE = 'h5-opCouponUse', // 使用优惠券
    OP_COUPON_RECEIVE = 'h5-opCouponReceive', // banner领取优惠券
    OP_PAYMENT_CANCEL_CLICK = 'h5-opPaymentCancelClick', // 支付方式
    OP_PAYMENT_CONFIRM_CLICK = 'h5-opPaymentConfirmClick', // 支付方式
    OP_PAYMENT_CLICK = 'h5-opPaymentClick', // 立即支付
    OP_PAYMENT_COUPON_CLICK = 'h5-opPaymentCouponClick', // 优惠券选择
}

export enum EVNET_TRACING_BANNER {
    BANNER1 = 'h5-banner1',
    BANNER2 = 'h5-banner2',
    BANNER3 = 'h5-banner3'
}

export enum EVENT_TRACING_MENU {
    MENU_COUPON = 'h5-menuMineCoupon', // 优惠卡券
}

// trybuy埋点 - 页面
export enum TRYBUY_EVENT_TRACING_PAGE {
    TRYBUY_PAGE_LOGIN = 'trybuy-page-login', // 登录页
    TRYBUG_PAGE_REGIST = 'trybuy-page-regist', // 注册页
    TRYBUY_PAGE_BINDSIM = 'trybuy-page-bindSim', // 绑卡页面
    TRYBUY_PAGE_HOME = 'trybuy-page-home', // 进入首页
}

// trybuy埋点 - 点击事件
export enum TRYBUY_EVENT_TRACING_CLICK {
    TRYBUY_LOGIN = 'trybuy-login',  // 登录
    TRYBUY_REGIST = 'trybuy-regist', // 注册
    TRYBUY_BIND_SIM = 'trybuy-bind-sim', // 执行绑卡
    TRYBUY_CLOSE_ACTIVE_MODAL = 'trybuy-close-active-modal', // 关闭激活弹窗
    TRYBUY_ACTIVE_PACKAGE_BY_MODAL = 'trybuy-active-package-by-modal', // 通过弹窗激活
    TRYBUY_ACTIVE_PACKAGE = 'trybuy-active-package', // 点击页面上的激活
    TRYBUY_CLICK_BASE_PACKAGE = 'trybuy-click-base-package', // 点击订购基础包
    TRYBUY_CLICK_ADD_PACKAGE = 'trybuy-click-add-package', // 点击订购加油包
    TRYBUY_ORDER_BASE_PACKAGE = 'trybuy-order-base-package', // 商品详情页点击订购基础包
    TRYBUY_ORDER_ADD_PACKAGE = 'trybuy-order-add-package', // 商品详情页点击订购加油包
    TRYBUY_BILL_ADDRESS_CLICK_CANCEL = 'trybuy-bill-address-click-cancel', // 登记地址页面点击取消
    TRYBUY_BILL_ADDRESS_CLICK_CONTINUE = 'trybuy-bill-address-click-continue', // 登记地址页面点击继续
}
export enum CHINA_EVENT_TRACING_PAGE {
    WAP_REPURCHASE_PAGE = 'wap_repurchase_page'
}
export enum CHINA_EVENT_TRACING_CLICK {
    WAP_REPURCHASE_BUY = 'wap_repurchase_buy',
    WAP_REPURCHASE_RECEIVECOUPONS = 'mp_repurchase_receiveCoupons',
}
export enum ACTIVE_STATUS {
    ACTIVE = 'active',
    ACTIVED = 'actived'
}

// 奖品类型
export enum LOTTERY_PRIZE_TYPE {
    MATERIAL = '实物',
    CHEAPER_COUPON = '优惠券',
    DATA_PLAN = '套餐',
    INTEGRAL = '积分'
}

export enum LOTTERY_PRIZE_TYPE_V {
    MATERIAL = 1,
    CHEAPER_COUPON = 2,
    DATA_PLAN = 3,
    INTEGRAL = 4
}

export const LANG = {
    zh: '1',
    en: '2',
    de: '3',
    es: '4',
    fr: '5',
    it: '6',
    pt: '7'
}
export enum INTEGRAL_GOOD_TYPE {
    MATERIAL = '实物',
    CHEAPER_COUPON = '优惠券',
    DATA_PLAN = '流量套餐'
}

export enum INTEGRAL_GOOD_TYPE_V {
    MATERIAL = '1',
    CHEAPER_COUPON = '2',
    DATA_PLAN = '3'
}

/**
 * 秒杀活动状态
 */
export enum SPKIE_STATUS {
    TO_START = '待开始',
    UNDERWAY = '进行中',
    UNDER_STOCK = '售罄',
    FINISH = '已结束'
}
export enum SPKIE_STATUS_V {
    TO_START = '0',
    UNDERWAY = '1',
    UNDER_STOCK = '2',
    FINISH = '3'
}
